export default __webpack_public_path__ + "static/media/php.441295dc.svg";